import { makeStyles } from "tss-react/mui";

const useSelectStyles = makeStyles()((theme) => ({
  root: {
    color: theme.palette.text.secondary,
  },
}));

export default useSelectStyles;
